import axios from "axios"
import {  baseUrlback } from "../urlApi"





export  const getEmpresaRepresentante = async (sid,empid,usuario) => {

    try {

      const response = await axios.post(`${baseUrlback}api/helpers/usuario`,{
        sid,empid,usuario
      })

      return response.data
      
    } catch (error) {
       console.log(error)
    }



  }


 export const consultarFirmaContratada = async (portal,emp) => {


     try {
       
         const response = await axios.post(`${baseUrlback}api/helpers/firmaContratada`, {
           sid:portal,empid:emp
         })


         return response.data

         
     } catch (error) {


        console.log(error)
       //  dispatch(setFirmaContratada('N'))
     }


}